"use strict";
/*
 * Copyright 2018 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MosaicFlags = void 0;

var catbuffer_typescript_1 = require("catbuffer-typescript");
/**
 * Mosaic flags model
 */


var MosaicFlags = /*#__PURE__*/function () {
  /**
   * @param flags
   */
  function MosaicFlags(flags) {
    _classCallCheck(this, MosaicFlags);

    this.supplyMutable = (flags & catbuffer_typescript_1.MosaicFlagsDto.SUPPLY_MUTABLE) !== 0;
    this.transferable = (flags & catbuffer_typescript_1.MosaicFlagsDto.TRANSFERABLE) !== 0;
    this.restrictable = (flags & catbuffer_typescript_1.MosaicFlagsDto.RESTRICTABLE) !== 0;
    this.revokable = (flags & catbuffer_typescript_1.MosaicFlagsDto.REVOKABLE) !== 0;
  }
  /**
   * Static constructor function with default parameters
   * @returns {MosaicFlags}
   * @param supplyMutable
   * @param transferable
   * @param restrictable
   * @param revokable
   */


  _createClass(MosaicFlags, [{
    key: "getValue",
    value:
    /**
     * Get mosaic flag value in number
     * @returns {number}
     */
    function getValue() {
      return MosaicFlags.toFlag(this);
    }
    /**
     * Create DTO object
     */

  }, {
    key: "toDTO",
    value: function toDTO() {
      return {
        flags: this.getValue()
      };
    }
    /**
     * It "adds up" individual flags into a bit wise number flag.
     *
     * @param supplyMutable - if the supply is mutable. First flag.
     * @param transferable - if the balance can be transferred. Second flag.
     * @param restrictable - if the transaction can be restricted. Third flag.
     * @param revokable - if the balance can be revoked. Fourth flag.
     * @private
     */

  }], [{
    key: "create",
    value: function create(supplyMutable, transferable) {
      var restrictable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var revokable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var flags = this.toFlag({
        supplyMutable: supplyMutable,
        transferable: transferable,
        restrictable: restrictable,
        revokable: revokable
      });
      return new MosaicFlags(flags);
    }
  }, {
    key: "toFlag",
    value: function toFlag(_ref) {
      var supplyMutable = _ref.supplyMutable,
          transferable = _ref.transferable,
          restrictable = _ref.restrictable,
          revokable = _ref.revokable;
      return (supplyMutable ? 1 : 0) + (transferable ? 2 : 0) + (restrictable ? 4 : 0) + (revokable ? 8 : 0);
    }
  }]);

  return MosaicFlags;
}();

exports.MosaicFlags = MosaicFlags;